import React from 'react';
import { Avatar } from '@mui/material';
import  PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import config from "../../config-site";

// import { useAuth } from '../../hooks/useAuth';

const address_api = config[0].address;
const useStyles = makeStyles({
  container: {
    with: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  username:{
    padding: 0,
    margin: 0,
    color: 'while'
  }
});

export default function User({user}) {
    
  const classes = useStyles()
  // useEffect(() => {


  return (
    <div className={classes.container} >
      <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, 
                display: { xs: 'none', sm: 'contents' }, 
                alignItems: 'center',
                fontFamily: 'b_mitra'
              }}
            color="primary"
            >
            
            <Avatar alt={user?.last_name} src={`${address_api}${user?.profile?.image}`} 
                sx={{ width: 45, height: 45 }}/>
        </Typography>
    </div>
  );
}

// User.propTypes = {
//   name: PropTypes.shape({
//     username: PropTypes.string.isRequired,
//     profile: PropTypes.shape({
//       image: PropTypes.string
//     }).isRequired
//   }).isRequired
// }
